import { render, staticRenderFns } from "./RecordDueNotification.vue?vue&type=template&id=5cf8555a&scoped=true&"
import script from "./RecordDueNotification.vue?vue&type=script&lang=js&"
export * from "./RecordDueNotification.vue?vue&type=script&lang=js&"
import style0 from "./RecordDueNotification.vue?vue&type=style&index=0&id=5cf8555a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf8555a",
  null
  
)

export default component.exports